<template>

  <v-card
    class="mx-auto my-12"
    max-width="500"
  >

     <v-progress-linear  style="margin : 0 auto ; height:10px" :indeterminate="isLoading" v-show="isLoading"></v-progress-linear>

    <v-card-title></v-card-title>

    <v-divider  class="mx-4"></v-divider>

    <v-card-title>{{instituicaodescricao}}</v-card-title>

    <v-card-text>
      <v-chip-group

        active-class="deep-purple accent-4 white--text"
        column
      >
        <v-chip>{{this.editedItem.quantidadeFuncionario}} Funcionarios</v-chip>

      </v-chip-group>
    </v-card-text>

  </v-card>
</template>
<script>
// const message = require('../config/messages')
import axios from '../../plugins/axios'
const ls = require('local-storage')
export default {
  data: () => ({
    instituicao: [],
    isLoading: true,
    editedItem: {

      quantidadeFuncionario: 0

    },
    defaultItem: {

      quantidadeFuncionario: 0

    }
  }),
  computed: {

    instituicaodescricao () {
      return ls.get('instituicaodescricao')
    },
    anolectivo () {
      return ls.get('anolectivo')
    },
    loggedUserName () {
      return ls.get('nomeUsuario')
    },
    role () {
      let rl = ''
      if (ls.get('role') === 'ROLE_ADM') {
        rl = 'logado como Administrador'
      } else if (ls.get('role') === 'ROLE_PROF') {
        rl = 'logado como Professor'
      } else if (ls.get('role') === 'ROLE_FUNC') {
        rl = 'logado como Funcionario'
      } else if (ls.get('role') === 'ROLE_EST') {
        rl = 'logado como Estudante'
      } else if (ls.get('role') === 'ROLE_DIR') {
        rl = 'logado como Director'
      } else if (ls.get('role') === 'ROLE_COOR') {
        rl = 'logado como Coordenador de Curso'
      } else if (ls.get('role') === 'ROLE_PED') {
        rl = 'logado como Coordenador de Curso'
      } else if (ls.get('role') === 'ROLE_PWR') {
        rl = 'logado como Usuário com Superiores Previlgêgios'
      } else if (ls.get('role') === 'ROLE_DIRCOL') {
        rl = 'logado como Director de Colégio'
      }
      return rl
    }

  },

  loggedUserName () {
    return ls.get('idPessoa')
  },
  created () {
    this.initInstituicao()
  },

  methods: {
    async initInstituicao () {
      this.isLoading = true
      try {
        this.instituicao = await axios
          .get('/quantidadeFuncionarios')
          .then(res => res.data)
        this.isLoading = false
        console.log('Dados ' + this.instituicao[0].quantidadeFuncionario)
        this.editedItem.quantidadeFuncionario = this.instituicao[0].quantidadeFuncionario
      } catch (error) {
        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    }

  }
}
</script>
